/* ------------------------------------------------------------
   Semakan post Shopee di phone — dua pintu yang tak boleh dibuktikan oleh
   "butang dah ditekan" (ukur 1 Nov, Redmi 14C):

   1. videoCardPalingBaru — robot tick video PERTAMA dalam galeri tanpa tahu video
      siapa. Sebelum buka Shopee, tanya Android video paling baru: mesti video card ini.
   2. sahkanPostDiProfil — lepas Post, Shopee upload di belakang dan robot tak boleh
      terus ke card seterusnya (buka card baru = tutup paksa app). Corak SAMA robot
      TikTok/FB Reels di browser: 6 cubaan ≈ 2 minit, padankan post di senarai akaun.

   Page yang diukur: profil = ReactActivity_ (senarai post boleh dibaca, post terbaru
   desc "click video 1"), page post = NativePlayerActivity (caption, produk, label AI
   boleh dibaca), sheet caption = ReactTransparentActivity_ (caption penuh + umur post).
   Kaunter post tiada di profil; bukti "post BARU" = caption padan + umur post.
------------------------------------------------------------ */
import { captionUntukFb } from './rancanganKalendar';

const delay = (ms) => new Promise((r) => setTimeout(r, ms));

// Caption post telefon = kotak "Facebook Caption" card (arahan user 3 Nov): caption FB
// sendiri → teks itu; tiada → ikut caption TikTok; FB sengaja dikosongkan → '' (card
// dilangkau "tiada caption"). Takrifan SAMA robot FB (captionUntukFb). Satu takrifan
// untuk Post to phone (Workspace), Test (PhoneAutomationView) + builder admin.
export function captionUntukPhone(set) {
  return String(captionUntukFb(set) || '').trim();
}

// Link yang runner boleh masukkan. Satu takrifan: dipakai step Tag product + semakan
// sebelum larian di Workspace. '' = boleh.
export function linkShopeeSalah(link) {
  const l = String(link || '').trim();
  if (!/^https:\/\/[^\s]*(shopee|shope\.ee)[^\s]*$/i.test(l)) return 'tiada-link-shopee';
  if (/[&;|()<>$`'"\\]/.test(l)) return 'link-ada-aksara-khas';
  return '';
}

/* Elak post Shopee BERGANDA (post Shopee tak boleh ditarik balik). Keputusan user 3 Nov:
   status yang KELIHATAN (pil card + slot) = larian TERAKHIR mana-mana platform (override,
   macam replace video), jadi pintu ini TIDAK lagi baca status kelihatan sahaja — status
   FB/TikTok tidak menghalang Shopee. Yang menghalang hanya bukti larian SHOPEE:
     tanda      = catatan tersembunyi `setStatuses.sp_setN` pada card (tak ditindih platform lain;
                  dikosongkan bila pelanggan kosongkan status — tulisStatusAkaunKad)
     slot / slotServer = slot kalendar (ingatan / server) yang larian terakhirnya Shopee (pf 'sp')
     rekodKad   = rekod pil card yang larian terakhirnya Shopee (pf 'sp')
   Draft tak menghalang (boleh jalan semula), kecuali Draft disimpan browser lain. */
const DIPROSES = new Set(['running', 'complete', 'uncertain']);
export function sudahMasukShopee({ tanda, slot, slotServer, rekodKad } = {}) {
  if (DIPROSES.has(tanda)) return true;
  if (slot?.pf === 'sp' && DIPROSES.has(slot.st)) return true;
  if (slotServer?.pf === 'sp' && (DIPROSES.has(slotServer.st) || (slotServer.st === 'draft' && slot?.st !== 'draft'))) return true;
  if (rekodKad?.pf === 'sp' && DIPROSES.has(rekodKad.st)) return true;
  return false;
}

// Sebab satu card tak boleh dijalankan, ayat untuk pelanggan. '' = boleh.
export function masalahIsiPost({ caption, productLink }) {
  const salah = linkShopeeSalah(productLink);
  if (salah === 'tiada-link-shopee') return 'tiada link Shopee';
  if (salah) return 'link Shopee tak boleh digunakan (panjang dengan aksara khas, guna link pendek)';
  if (!String(caption || '').trim()) return 'tiada caption';
  return '';
}

const CUBAAN_TUNGGU_MS = [10000, 10000, 10000, 10000, 10000, 15000];

async function fokus(controller) {
  try { return await controller.getFocusedWindow(); } catch { return ''; }
}

async function tungguFokus(controller, nama, ms = 6000) {
  for (const hingga = Date.now() + ms; Date.now() < hingga;) {
    if ((await fokus(controller)).includes(nama)) return true;
    await delay(500);
  }
  return false;
}

// Android kadang lambat mengimbas fail baru, jadi cuba beberapa kali + imbas semula sekali.
export async function videoCardPalingBaru(controller, dest) {
  const mahu = String(dest || '').split('/').pop();
  if (!mahu) return false;
  for (let k = 0; k < 8; k++) {
    if ((await controller.newestVideoName()) === mahu) return true;
    if (k === 3) await controller.mediaScan(dest);
    await delay(1500);
  }
  return false;
}

// "lipas asyik muncul dekat dapur m ... See more" → bahagian caption yang kelihatan.
const bersih = (t) => String(t || '').replace(/\s*\.\.\.\s*see more\s*$/i, '').replace(/\s+/g, ' ').trim().toLowerCase();

// "26 minutes ago" = lama. Post larian ini paling lewat beberapa minit, jadi jam/hari/
// tarikh atau lebih 10 minit bukan post ini. Teks kosong/tak dikenali tak dianggap lama.
function postLama(umur) {
  if (/\b(hour|day|week|month|year)s?\b|\d{1,4}[-/]\d{1,2}/i.test(umur)) return true;
  const min = umur.match(/(\d+)\s*min/i);
  return !!min && Number(min[1]) > 10;
}

async function bacaPagePost(controller) {
  for (let k = 0; k < 2; k++) {
    try { return await controller.dumpUiElements(); } catch { await delay(1500); }
  }
  return null;
}

async function satuCubaan(controller, { caption, profil, screens }) {
  const sw = controller?.info?.screenWidth || 720;
  const sh = controller?.info?.screenHeight || 1280;
  await controller.tap(profil.rx * sw, profil.ry * sh);
  if (!(await tungguFokus(controller, screens.profile))) return { sebab: 'profil-tak-buka' };
  await delay(2500);
  const senarai = await bacaPagePost(controller);
  const video1 = (senarai || []).find((e) => e.bounds && /^click video 1$/i.test(e.desc || ''));
  if (!video1) { await controller.back(); return { sebab: 'senarai-post-tak-dibaca' }; }
  await controller.tap((video1.bounds.x1 + video1.bounds.x2) / 2, (video1.bounds.y1 + video1.bounds.y2) / 2);
  if (!(await tungguFokus(controller, screens.player))) { await controller.back(); return { sebab: 'post-tak-terbuka' }; }
  await delay(1500);
  const els = await bacaPagePost(controller);
  const kotak = (els || []).find((e) => e.bounds && /^video caption content$/i.test(e.desc || ''));
  const dalam = kotak && els.find((e) => e !== kotak && e.text && e.bounds?.y1 === kotak.bounds.y1);
  const nampak = bersih(kotak?.text || dalam?.text);
  const mahu = bersih(caption);
  // Page post potong caption panjang, jadi yang kelihatan mesti permulaan caption card.
  if (els && (mahu ? (nampak && mahu.startsWith(nampak)) : !nampak)) {
    const hasil = {
      padan: true,
      produk: els.some((e) => /^click video product icon$/i.test(e.desc || '')),
      aiLabel: els.some((e) => /labeled as ai-generated/i.test(e.text || '')),
      captionPenuh: nampak === mahu,
    };
    if (/see more\s*$/i.test(kotak?.text || dalam?.text || '')) {
      // Tekan "See more" (hujung kanan, bukan tengah: tengah boleh kena hashtag) buka
      // sheet: caption PENUH + umur post. Ikon komen pula naikkan keyboard, jangan guna.
      await controller.tap(kotak.bounds.x2 - 30, (kotak.bounds.y1 + kotak.bounds.y2) / 2);
      if (!(await tungguFokus(controller, screens.productSheet, 5000))) { await controller.back(); return { sebab: 'sheet-caption-tak-buka' }; }
      await delay(1200);
      const sheet = (await bacaPagePost(controller)) || [];
      const teksCap = sheet.find((e) => e.bounds && bersih(e.text).startsWith(nampak));
      if (!teksCap) { await controller.back(); await delay(800); await controller.back(); return { sebab: 'caption-penuh-tak-dibaca' }; }
      hasil.captionPenuh = bersih(String(teksCap.text).replace(/\s*hide\s*$/i, '')) === mahu;
      const masa = sheet
        .filter((e) => e.text && e.bounds && e.bounds.y1 >= teksCap.bounds.y2)
        .sort((a, b) => a.bounds.y1 - b.bounds.y1)[0];
      hasil.umur = String(masa?.text || '').trim();
      await controller.back(); // tutup sheet
      // Caption sama + post lama = bukan post larian ini (card kembar caption sama).
      if (postLama(hasil.umur)) {
        await delay(800);
        await controller.back();
        await delay(800);
        await controller.back();
        return { sebab: `post-terbaru-lama:${hasil.umur}` };
      }
    }
    return hasil;
  }
  await controller.back();
  await delay(800);
  await controller.back();
  return { sebab: 'post-terbaru-bukan-card-ini' };
}

// Pulang { ok:true, produk, aiLabel } atau { ok:false, sebab }. Telefon mesti di feed.
export async function sahkanPostDiProfil(controller, { caption, profil, screens, log = () => {} }) {
  let sebab = 'tiada-cubaan';
  for (let i = 0; i < CUBAAN_TUNGGU_MS.length; i++) {
    try {
      const r = await satuCubaan(controller, { caption, profil, screens });
      if (r.padan) {
        log(`Post disahkan di profil (cubaan ${i + 1}/${CUBAAN_TUNGGU_MS.length}, umur "${r.umur || '-'}").`, 'ok');
        return { ok: true, produk: r.produk, aiLabel: r.aiLabel, captionPenuh: r.captionPenuh, umur: r.umur };
      }
      sebab = r.sebab;
    } catch (e) {
      sebab = e?.message || String(e);
    }
    log(`Semak post cubaan ${i + 1}/${CUBAAN_TUNGGU_MS.length}: ${sebab}`, 'warn');
    await delay(CUBAAN_TUNGGU_MS[i]);
  }
  return { ok: false, sebab };
}
